import CheckHttpStatus from "fetch-check-http-status";

const extractWishListIdFromResponse = (response: string) => {
  const doc = new DOMParser().parseFromString(response, "text/html");
  const wishListIdElement = doc.querySelector("data")?.textContent;
  let wishListId: number | undefined;
  if (wishListIdElement) {
    wishListId = Number(wishListIdElement);
  }
  return wishListId;
};

const fetchCreateNewWishList = async (
  wishListName: string,
  userIndex: string
): Promise<number | undefined> => {
  const data = new FormData();
  data.append("method", "createWishList");
  data.append("newWishListName", wishListName);
  data.append("userindex", userIndex);

  const wishListId = await fetch("/object/newwishlist.cfc", {
    method: "POST",
    body: data,
  })
    .then(CheckHttpStatus)
    .then((response) => response.text())
    .then((response) => extractWishListIdFromResponse(response));

  return wishListId;
};

export default fetchCreateNewWishList;
